/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetMfaCredentials200ResponseCredentialsInner } from './GetMfaCredentials200ResponseCredentialsInner';
import {
    GetMfaCredentials200ResponseCredentialsInnerFromJSON,
    GetMfaCredentials200ResponseCredentialsInnerFromJSONTyped,
    GetMfaCredentials200ResponseCredentialsInnerToJSON,
    GetMfaCredentials200ResponseCredentialsInnerToJSONTyped,
} from './GetMfaCredentials200ResponseCredentialsInner';

/**
 * Successful response
 * @export
 * @interface GetMfaCredentials200Response
 */
export interface GetMfaCredentials200Response {
    /**
     * 
     */
    credentials?: Array<GetMfaCredentials200ResponseCredentialsInner>;
}

/**
 * Check if a given object implements the GetMfaCredentials200Response interface.
 */
export function instanceOfGetMfaCredentials200Response(value: object): value is GetMfaCredentials200Response {
    return true;
}

export function GetMfaCredentials200ResponseFromJSON(json: any): GetMfaCredentials200Response {
    return GetMfaCredentials200ResponseFromJSONTyped(json, false);
}

export function GetMfaCredentials200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMfaCredentials200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'credentials': json['credentials'] == null ? undefined : ((json['credentials'] as Array<any>).map(GetMfaCredentials200ResponseCredentialsInnerFromJSON)),
    };
}

export function GetMfaCredentials200ResponseToJSON(json: any): GetMfaCredentials200Response {
    return GetMfaCredentials200ResponseToJSONTyped(json, false);
}

export function GetMfaCredentials200ResponseToJSONTyped(value?: GetMfaCredentials200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'credentials': value['credentials'] == null ? undefined : ((value['credentials'] as Array<any>).map(GetMfaCredentials200ResponseCredentialsInnerToJSON)),
    };
}

